import { TourConfig, startTour, CONTINUE_PLATFORM_TOUR_BUTTON } from './TourSystem';
import PageWelcomeModal from './PageWelcomeModal';
import 'driver.js/dist/driver.css';

const projectsTourConfig: TourConfig = {
    tourId: 'projects',
    steps: [
        {
            element: '#projects-create-btn',
            popover: {
                title: '➕ Create New Project',
                description: 'Ready to start something new? Click here to launch the project wizard. You can set up names, add descriptions, and assign teammates immediately.',
                side: "bottom",
            }
        },
        {
            element: '#projects-filters',
            popover: {
                title: '🎛️ Control Center',
                description: 'This toolbar is your command deck for managing project visibility. Use these controls to slice and dice your project list.',
                side: "bottom",
            }
        },
        {
            element: '#projects-filter-all',
            popover: {
                title: '📝 Show All',
                description: 'Click here to see everything. This view gives you a complete picture of your entire project history.',
                side: "bottom",
            }
        },
        {
            element: '#projects-filter-active',
            popover: {
                title: '⚡ Active Projects',
                description: 'Focus on what matters now. Filter to see only the projects that are currently in progress.',
                side: "bottom",
            }
        },
        {
            element: '#projects-filter-completed',
            popover: {
                title: '✅ Completed Work',
                description: 'Review your success. Access your archive of finished projects and their details.',
                side: "bottom",
            }
        },
        {
            element: '#projects-search-input',
            popover: {
                title: '🔍 Global Search',
                description: 'Looking for something specific? Type any keyword here to instantly find projects by name or description.',
                side: "bottom",
            }
        },
        {
            element: '#projects-grid',
            popover: {
                title: '📂 Project Portfolio',
                description: `This grid displays your work. Each card is a portal to that project's specific dashboard. Click a card to enter its workspace.${CONTINUE_PLATFORM_TOUR_BUTTON}`,
                side: "top",
            }
        }
    ],
};

export const startProjectsTour = () => {
    startTour(projectsTourConfig);
};

const ProjectsTour = () => {
    return (
        <PageWelcomeModal
            title="Welcome to Projects"
            description="Let us show you how to manage your work and collaborations efficiently."
            onStartTour={startProjectsTour}
            tourId="projects"
        />
    );
};

export default ProjectsTour;
